import { useTranslation } from 'react-i18next';

const Translate = ({i18nKey}) => {
  const {t} = useTranslation();
  return t(i18nKey);
};

export default Translate;